import React from "react";

interface ToolbarButton {
  id: string;
  icon: string;
  title: string;
  onClick?: () => void;
}

interface FloatingToolbarProps {
  buttons?: ToolbarButton[];
  helpButton?: ToolbarButton;
  activeButtonId?: string;
  position?: "left" | "right";
  iconColor?: string;
  activeIconColor?: string;
  activeBackgroundColor?: string;
  activeBorderColor?: string;
  backgroundColor?: string;
  backdropBlur?: string;
  borderColor?: string;
  boxShadow?: string;
  dividerColor?: string;
}

export function FloatingToolbar({
  buttons = [
    { id: "tools", icon: "construction", title: "Tools" },
    { id: "parts", icon: "account_tree", title: "Parts List" },
    { id: "sound", icon: "volume_up", title: "Sound" },
    { id: "tutorial", icon: "school", title: "Tutorial" },
  ],

  helpButton = { id: "help", icon: "help", title: "Help" },
  activeButtonId,
  position = "right",
  iconColor = "rgba(255, 255, 255, 0.8)",
  activeIconColor = "rgba(255, 255, 255, 0.95)",
  activeBackgroundColor = "rgba(255, 255, 255, 0.15)",
  activeBorderColor = "rgba(255, 255, 255, 0.2)",
  backgroundColor = "rgba(55, 55, 55, 0.85)",
  backdropBlur = "24px",
  borderColor = "rgba(255, 255, 255, 0.12)",
  boxShadow = "0 8px 32px 0 rgba(0, 0, 0, 0.4)",
  dividerColor = "rgba(255, 255, 255, 0.2)",
}: FloatingToolbarProps) {
  return (
    <aside
      style={{
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        [position]: "1.5rem",
        zIndex: 100,
      }}
      data-oid="6am6zjk"
    >
      <div
        style={{
          backgroundColor: backgroundColor,
          backdropFilter: `blur(${backdropBlur})`,
          WebkitBackdropFilter: `blur(${backdropBlur})`,
          border: `1px solid ${borderColor}`,
          boxShadow: boxShadow,
          borderRadius: "1.5rem",
          padding: "0.75rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
        data-oid="3fv0:ed"
      >
        {buttons.map((button) => {
          const isActive = button.id === activeButtonId;
          return (
            <button
              key={button.id}
              onClick={button.onClick}
              title={button.title}
              style={{
                width: "3rem",
                height: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "0.75rem",
                border: isActive
                  ? `1px solid ${activeBorderColor}`
                  : "1px solid transparent",
                background: isActive ? activeBackgroundColor : "transparent",
                color: isActive ? activeIconColor : iconColor,
                cursor: "pointer",
                transition: "all 0.3s",
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = "#ffffff";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = iconColor;
                  e.currentTarget.style.background = "transparent";
                }
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = "scale(0.9)";
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
              data-oid="90lfvkb"
            >
              <span
                className="material-symbols-outlined"
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 300,
                }}
                data-oid="gf:5tcr"
              >
                {button.icon}
              </span>
            </button>
          );
        })}

        {helpButton && (
          <>
            <div
              style={{
                width: "100%",
                height: "1px",
                backgroundColor: dividerColor,
              }}
              data-oid="p16x7x_"
            />

            <button
              onClick={helpButton.onClick}
              title={helpButton.title}
              style={(() => {
                const isHelpActive = helpButton.id === activeButtonId;

                return {
                  width: "3rem",
                  height: "3rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "0.75rem",
                  border: isHelpActive
                    ? `1px solid ${activeBorderColor}`
                    : "1px solid transparent",
                  background: isHelpActive
                    ? activeBackgroundColor
                    : "transparent",
                  color: isHelpActive ? activeIconColor : iconColor,
                  cursor: "pointer",
                  transition: "all 0.3s",
                };
              })()}
              onMouseEnter={(e) => {
                if (helpButton.id !== activeButtonId) {
                  e.currentTarget.style.color = "#ffffff";
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (helpButton.id !== activeButtonId) {
                  e.currentTarget.style.color = iconColor;
                  e.currentTarget.style.background = "transparent";
                }
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = "scale(0.9)";
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
              data-oid="1vuaah-"
            >
              <span
                className="material-symbols-outlined"
                style={{
                  fontSize: "1.5rem",
                  fontWeight: 300,
                }}
                data-oid="3rdgenp"
              >
                {helpButton.icon}
              </span>
            </button>
          </>
        )}
      </div>
    </aside>
  );
}
